// AUTO-GENERATED by scripts/convert-rn-icons.ts from libs/component-library/src/lib/icons/icons.tsx - do not edit.
import { FxSvg, type FxSvgProps } from '../FxSvg.js';

export const FxPlusIcon = (props: FxSvgProps) => (
  <FxSvg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path
      d="M12.5 2.75C12.5 2.33579 12.1642 2 11.75 2C11.3358 2 11 2.33579 11 2.75V11H2.75C2.33579 11 2 11.3358 2 11.75C2 12.1642 2.33579 12.5 2.75 12.5H11V20.75C11 21.1642 11.3358 21.5 11.75 21.5C12.1642 21.5 12.5 21.1642 12.5 20.75V12.5H20.75C21.1642 12.5 21.5 12.1642 21.5 11.75C21.5 11.3358 21.1642 11 20.75 11H12.5V2.75Z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </FxSvg>
);
